<button class="btn btn-primary mr-1" mat-button (click)="loaderOn()">turn on loader for 5 seconds</button>

<button class="btn btn-primary mr-1" mat-button (click)="openYesNo()">open yes/no dialog</button>

<button class="btn btn-primary" mat-button (click)="openInfo()">open info dialog</button>